import React, {useEffect, useRef, useState} from "react";
import {CreditCard, PaymentForm} from "react-square-web-payments-sdk";
import {lookupClientSecret, squarePay, squareSave} from "./app/common/api/CartApi";
import Checkbox from "@mui/material/Checkbox";

export default function SquareCheckoutPage({cart, handleSuccess, handleError, storeCard}) {

  const [stripePromise, setStripePromise] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [clientCart, setClientCart] = useState(cart);

  const targetRef = useRef(null);

  useEffect(() => {
    lookupClientSecret().then((result) => {
      setApplicationId(result['applicationId']);

      const timer = setTimeout(() => {
        if (targetRef.current) {
          targetRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 10);
      // Cleanup function to clear the timeout when the component unmounts
      return () => clearTimeout(timer);

    });
  }, []);

  const [processing, setProcessing] = useState(false);

  const squarePayFn = async (payment) => {
    if (processing) {
      return;
    }
    setProcessing(true);
    let _cart = {...clientCart}
    _cart.cardNonce = payment.sourceId;
    _cart.cartStoreCard = cartStoreCard;
    if (storeCard) {
      squareSave(_cart).then((resp) => {
        handleSuccess(resp.data);
      }).catch(function (error) {
        return handleError(error);
      });
    } else {
      squarePay(_cart).then((resp) => {
        handleSuccess(resp.data)
      }).catch(function (error) {
        return handleError(error);
      });
    }
  }

  const [cardToken, setCardToken] = useState(null);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [cartStoreCard, setCartStoreCard] = useState(false);

  return (
    <div>
      {applicationId && <div style={{
        border: 'solid 1px #111',
        borderRadius: '20px',
        margin: '10px -20px',
        padding: '12px'
      }}>
        <p style={{
          color: 'red !important',
        }}><label htmlFor={'agree-terms'}>
          <Checkbox style={{
            float: 'left',
          }}
                    onChange={(e) => {
                      setAgreeTerms(e.target.checked)
                    }}
                    id="agree-terms"/>
          &nbsp;<small style={{
          color: "#000 !important"
        }}>By placing an order or storing card for future use,
          you agree to our <a href={'#cx/privacy'} target={"_blank"}>privacy notice</a> and <a
          href={'#cx/terms-of-service'} target={"_blank"}> conditions of use</a>
        </small></label></p>

        {!cart?.cardRequired && <>
          <p style={{
            color: 'red !important',
          }}><label htmlFor={'store-card'}>
            <Checkbox
              onChange={(e) => {
                setCartStoreCard(e.target.checked)
              }}
              id="store-card"/>
            &nbsp;<small style={{
            color: "#000 !important"
          }}>
            Store card for future use
          </small></label>
          </p>
        </>}

        <div style={{
          disabled: true,
          opacity: agreeTerms ? 1 : 0.4,
          pointerEvents: agreeTerms ? 'inherit' : 'none'
        }}>
          <PaymentForm
            applicationId={applicationId}
            cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
              let payment = {sourceId: token.token}
              squarePayFn(payment).then((resp) => {
              });
            }}
            locationId='XXXXXXXXXX'
          >
            <CreditCard
              disabled={processing || !agreeTerms}
              buttonProps={{
                css: {
                  backgroundColor: "#771520",
                  fontSize: "14px",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#530f16",
                  },
                },
              }}
            >
              {storeCard ? 'Save' : processing ? 'Processing...' : 'Pay'}
            </CreditCard>
          </PaymentForm>
          {processing && <div style={{
            textAlign: 'center',
            height: '144px',
            width: '100%',
            position: 'absolute',
            bottom: '0',
            background: 'rgba(255,255,255,0)',
            zIndex: '999'
          }}></div>}
        </div>

      </div>
      }
      <div style={{
        position: 'relative',
        bottom: '-120px'
      }} ref={targetRef}>&nbsp;</div>
    </div>
  );
}